import { useLocale } from '@dreamstack/i18n'
import type { RouterOutputs } from '@dreamstack/trpc/client'
import { trpc } from '@dreamstack/trpc/client'

type GetPropertyByIdOutput = RouterOutputs['property']['getPropertyById']

export type FullPropertyByIdData = GetPropertyByIdOutput | undefined

export const useFetchFullPropertyById = ({
  id,
  disableSSR,
}: {
  id: number
  disableSSR?: boolean
}) => {
  const locale = useLocale()
  const {
    data,
    isPending: isLoading,
    error,
  } = trpc.property.getPropertyById.useQuery(
    { id, locale },
    { trpc: { ssr: !disableSSR }, staleTime: 1000 }
  )
  const property: FullPropertyByIdData = data

  return { property, loading: isLoading, error }
}
